import axios, { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PUT_WLAS_CONFIG } from '@/constants';
import {
  WlasFilters,
  WlasValues,
} from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/utils';
import { toApiFilters, toApiParams } from '@/features/pages/profile/wlas-widget/wlasConfigApi';
import { WLAS_CONFIG_QUERY_KEY } from './useGetWlasConfig';

export interface WlasConfigPayload {
  params: WlasValues;
  filters: WlasFilters;
}

const saveWlasConfig = (data: WlasConfigPayload): Promise<void> =>
  axios
    .put<void>(PUT_WLAS_CONFIG, {
      params: toApiParams(data.params),
      filters: toApiFilters(data.filters, data.params),
    })
    .then((res) => res.data);

export const useUpdateWlasConfig = () => {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, WlasConfigPayload>({
    mutationFn: saveWlasConfig,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: WLAS_CONFIG_QUERY_KEY });
    },
  });
};
